/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */
import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { useQuery, useMutation } from "@tanstack/react-query";
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey,
} from "@tanstack/react-query";
import type {
  DispositiviPageDto,
  GetDispositiviParams,
  DispositivoType,
  RegistroDto,
  DispositivoActionResultDto,
  DispositivoActionDto,
  UpdateRegistroResultDto,
  UpdateRegistroDto,
  RegistriMode,
  NexusUpdateDto,
  ProprietaMisurataValueDto,
  GetDispositivoHistoryDataParams,
  NexusOverlayDto,
  GetDispositivoAnalisiDataParams,
  GenerateReportProprietaMisurataDto,
} from ".././models";

export const getDispositivi = (
  portale: 1 | 2 | 3,
  tipo: DispositivoType,
  params?: GetDispositiviParams,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<DispositiviPageDto>> => {
  return axios.get(`/api/portali/${portale}/dispositivi/${tipo}`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetDispositiviQueryKey = (
  portale: 1 | 2 | 3,
  tipo: DispositivoType,
  params?: GetDispositiviParams
) =>
  [
    `/api/portali/${portale}/dispositivi/${tipo}`,
    ...(params ? [params] : []),
  ] as const;

export const getGetDispositiviQueryOptions = <
  TData = Awaited<ReturnType<typeof getDispositivi>>,
  TError = AxiosError<unknown>
>(
  portale: 1 | 2 | 3,
  tipo: DispositivoType,
  params?: GetDispositiviParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDispositivi>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof getDispositivi>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDispositiviQueryKey(portale, tipo, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDispositivi>>> = ({
    signal,
  }) => getDispositivi(portale, tipo, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(portale && tipo), ...queryOptions };
};

export type GetDispositiviQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDispositivi>>
>;
export type GetDispositiviQueryError = AxiosError<unknown>;

export const useGetDispositivi = <
  TData = Awaited<ReturnType<typeof getDispositivi>>,
  TError = AxiosError<unknown>
>(
  portale: 1 | 2 | 3,
  tipo: DispositivoType,
  params?: GetDispositiviParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDispositivi>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDispositiviQueryOptions(
    portale,
    tipo,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getRegistriDispositivo = (
  id: number,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<RegistroDto[]>> => {
  return axios.get(`/api/dispositivi/${id}/registri`, options);
};

export const getGetRegistriDispositivoQueryKey = (id: number) =>
  [`/api/dispositivi/${id}/registri`] as const;

export const getGetRegistriDispositivoQueryOptions = <
  TData = Awaited<ReturnType<typeof getRegistriDispositivo>>,
  TError = AxiosError<unknown>
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRegistriDispositivo>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof getRegistriDispositivo>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRegistriDispositivoQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRegistriDispositivo>>
  > = ({ signal }) => getRegistriDispositivo(id, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetRegistriDispositivoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRegistriDispositivo>>
>;
export type GetRegistriDispositivoQueryError = AxiosError<unknown>;

export const useGetRegistriDispositivo = <
  TData = Awaited<ReturnType<typeof getRegistriDispositivo>>,
  TError = AxiosError<unknown>
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRegistriDispositivo>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetRegistriDispositivoQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const actionDispositivo = (
  id: number,
  dispositivoActionDto: DispositivoActionDto,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<DispositivoActionResultDto>> => {
  return axios.put(
    `/api/${id}/dispositivoAction`,
    dispositivoActionDto,
    options
  );
};

export const getActionDispositivoMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof actionDispositivo>>,
    TError,
    { id: number; data: DispositivoActionDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof actionDispositivo>>,
  TError,
  { id: number; data: DispositivoActionDto },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof actionDispositivo>>,
    { id: number; data: DispositivoActionDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return actionDispositivo(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActionDispositivoMutationResult = NonNullable<
  Awaited<ReturnType<typeof actionDispositivo>>
>;
export type ActionDispositivoMutationBody = DispositivoActionDto;
export type ActionDispositivoMutationError = AxiosError<unknown>;

export const useActionDispositivo = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof actionDispositivo>>,
    TError,
    { id: number; data: DispositivoActionDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getActionDispositivoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const updateRegistriDispositivo = (
  id: number,
  mode: RegistriMode,
  updateRegistroDto: UpdateRegistroDto[],
  options?: AxiosRequestConfig
): Promise<AxiosResponse<UpdateRegistroResultDto[]>> => {
  return axios.put(
    `/api/dispositivi/${id}/registri/${mode}`,
    updateRegistroDto,
    options
  );
};

export const getUpdateRegistriDispositivoMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRegistriDispositivo>>,
    TError,
    { id: number; mode: RegistriMode; data: UpdateRegistroDto[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRegistriDispositivo>>,
  TError,
  { id: number; mode: RegistriMode; data: UpdateRegistroDto[] },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRegistriDispositivo>>,
    { id: number; mode: RegistriMode; data: UpdateRegistroDto[] }
  > = (props) => {
    const { id, mode, data } = props ?? {};

    return updateRegistriDispositivo(id, mode, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRegistriDispositivoMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateRegistriDispositivo>>
>;
export type UpdateRegistriDispositivoMutationBody = UpdateRegistroDto[];
export type UpdateRegistriDispositivoMutationError = AxiosError<unknown>;

export const useUpdateRegistriDispositivo = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRegistriDispositivo>>,
    TError,
    { id: number; mode: RegistriMode; data: UpdateRegistroDto[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getUpdateRegistriDispositivoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const bancoFlussaggioCalcolaPortata = (
  id: number,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<UpdateRegistroResultDto[]>> => {
  return axios.put(
    `/api/dispositivi/${id}/bancoFlussaggioCalcolaPortata`,
    undefined,
    options
  );
};

export const getBancoFlussaggioCalcolaPortataMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bancoFlussaggioCalcolaPortata>>,
    TError,
    { id: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bancoFlussaggioCalcolaPortata>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bancoFlussaggioCalcolaPortata>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return bancoFlussaggioCalcolaPortata(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BancoFlussaggioCalcolaPortataMutationResult = NonNullable<
  Awaited<ReturnType<typeof bancoFlussaggioCalcolaPortata>>
>;

export type BancoFlussaggioCalcolaPortataMutationError = AxiosError<unknown>;

export const useBancoFlussaggioCalcolaPortata = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bancoFlussaggioCalcolaPortata>>,
    TError,
    { id: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions =
    getBancoFlussaggioCalcolaPortataMutationOptions(options);

  return useMutation(mutationOptions);
};
export const updateNexus = (
  id: number,
  nexusUpdateDto: NexusUpdateDto,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.put(`/api/dispositivi/${id}/nexus`, nexusUpdateDto, options);
};

export const getUpdateNexusMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNexus>>,
    TError,
    { id: number; data: NexusUpdateDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateNexus>>,
  TError,
  { id: number; data: NexusUpdateDto },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNexus>>,
    { id: number; data: NexusUpdateDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateNexus(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateNexusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateNexus>>
>;
export type UpdateNexusMutationBody = NexusUpdateDto;
export type UpdateNexusMutationError = AxiosError<unknown>;

export const useUpdateNexus = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNexus>>,
    TError,
    { id: number; data: NexusUpdateDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getUpdateNexusMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getDispositivoHistoryData = (
  id: number,
  idMisura: number,
  params?: GetDispositivoHistoryDataParams,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<ProprietaMisurataValueDto[]>> => {
  return axios.get(`/api/dispositivi/${id}/misura/${idMisura}/history`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetDispositivoHistoryDataQueryKey = (
  id: number,
  idMisura: number,
  params?: GetDispositivoHistoryDataParams
) =>
  [
    `/api/dispositivi/${id}/misura/${idMisura}/history`,
    ...(params ? [params] : []),
  ] as const;

export const getGetDispositivoHistoryDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getDispositivoHistoryData>>,
  TError = AxiosError<unknown>
>(
  id: number,
  idMisura: number,
  params?: GetDispositivoHistoryDataParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDispositivoHistoryData>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof getDispositivoHistoryData>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDispositivoHistoryDataQueryKey(id, idMisura, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDispositivoHistoryData>>
  > = ({ signal }) =>
    getDispositivoHistoryData(id, idMisura, params, {
      signal,
      ...axiosOptions,
    });

  return { queryKey, queryFn, enabled: !!(id && idMisura), ...queryOptions };
};

export type GetDispositivoHistoryDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDispositivoHistoryData>>
>;
export type GetDispositivoHistoryDataQueryError = AxiosError<unknown>;

export const useGetDispositivoHistoryData = <
  TData = Awaited<ReturnType<typeof getDispositivoHistoryData>>,
  TError = AxiosError<unknown>
>(
  id: number,
  idMisura: number,
  params?: GetDispositivoHistoryDataParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDispositivoHistoryData>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDispositivoHistoryDataQueryOptions(
    id,
    idMisura,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getDispositivoAnalisiData = (
  id: number,
  idMisura: number,
  params?: GetDispositivoAnalisiDataParams,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<NexusOverlayDto[]>> => {
  return axios.get(`/api/dispositivi/${id}/misura/${idMisura}/analisi`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetDispositivoAnalisiDataQueryKey = (
  id: number,
  idMisura: number,
  params?: GetDispositivoAnalisiDataParams
) =>
  [
    `/api/dispositivi/${id}/misura/${idMisura}/analisi`,
    ...(params ? [params] : []),
  ] as const;

export const getGetDispositivoAnalisiDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getDispositivoAnalisiData>>,
  TError = AxiosError<unknown>
>(
  id: number,
  idMisura: number,
  params?: GetDispositivoAnalisiDataParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDispositivoAnalisiData>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof getDispositivoAnalisiData>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDispositivoAnalisiDataQueryKey(id, idMisura, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDispositivoAnalisiData>>
  > = ({ signal }) =>
    getDispositivoAnalisiData(id, idMisura, params, {
      signal,
      ...axiosOptions,
    });

  return { queryKey, queryFn, enabled: !!(id && idMisura), ...queryOptions };
};

export type GetDispositivoAnalisiDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDispositivoAnalisiData>>
>;
export type GetDispositivoAnalisiDataQueryError = AxiosError<unknown>;

export const useGetDispositivoAnalisiData = <
  TData = Awaited<ReturnType<typeof getDispositivoAnalisiData>>,
  TError = AxiosError<unknown>
>(
  id: number,
  idMisura: number,
  params?: GetDispositivoAnalisiDataParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDispositivoAnalisiData>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDispositivoAnalisiDataQueryOptions(
    id,
    idMisura,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const generateReportProprietaMisurata = (
  portale: 1 | 2 | 3,
  id: number,
  generateReportProprietaMisurataDto: GenerateReportProprietaMisurataDto,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<Blob>> => {
  return axios.post(
    `/api/portali/${portale}/dispositivi/${id}/report_proprieta_misurata_pdf`,
    generateReportProprietaMisurataDto,
    {
      responseType: "blob",
      ...options,
    }
  );
};

export const getGenerateReportProprietaMisurataMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateReportProprietaMisurata>>,
    TError,
    {
      portale: 1 | 2 | 3;
      id: number;
      data: GenerateReportProprietaMisurataDto;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateReportProprietaMisurata>>,
  TError,
  { portale: 1 | 2 | 3; id: number; data: GenerateReportProprietaMisurataDto },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateReportProprietaMisurata>>,
    { portale: 1 | 2 | 3; id: number; data: GenerateReportProprietaMisurataDto }
  > = (props) => {
    const { portale, id, data } = props ?? {};

    return generateReportProprietaMisurata(portale, id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateReportProprietaMisurataMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateReportProprietaMisurata>>
>;
export type GenerateReportProprietaMisurataMutationBody =
  GenerateReportProprietaMisurataDto;
export type GenerateReportProprietaMisurataMutationError = AxiosError<unknown>;

export const useGenerateReportProprietaMisurata = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateReportProprietaMisurata>>,
    TError,
    {
      portale: 1 | 2 | 3;
      id: number;
      data: GenerateReportProprietaMisurataDto;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions =
    getGenerateReportProprietaMisurataMutationOptions(options);

  return useMutation(mutationOptions);
};
export const generaCertificatoMQTT = (
  id: number,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<Blob>> => {
  return axios.get(`/api/dispositivi/${id}/certificato_mqtt`, {
    responseType: "blob",
    ...options,
  });
};

export const getGeneraCertificatoMQTTQueryKey = (id: number) =>
  [`/api/dispositivi/${id}/certificato_mqtt`] as const;

export const getGeneraCertificatoMQTTQueryOptions = <
  TData = Awaited<ReturnType<typeof generaCertificatoMQTT>>,
  TError = AxiosError<unknown>
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof generaCertificatoMQTT>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof generaCertificatoMQTT>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGeneraCertificatoMQTTQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof generaCertificatoMQTT>>
  > = ({ signal }) => generaCertificatoMQTT(id, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GeneraCertificatoMQTTQueryResult = NonNullable<
  Awaited<ReturnType<typeof generaCertificatoMQTT>>
>;
export type GeneraCertificatoMQTTQueryError = AxiosError<unknown>;

export const useGeneraCertificatoMQTT = <
  TData = Awaited<ReturnType<typeof generaCertificatoMQTT>>,
  TError = AxiosError<unknown>
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof generaCertificatoMQTT>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGeneraCertificatoMQTTQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const __$$useGetDispositivi = () =>
  //@ts-ignore
  useGetDispositivi(...([] as any[]));

export const __$$useGetRegistriDispositivo = () =>
  //@ts-ignore
  useGetRegistriDispositivo(...([] as any[]));

export const __$$useActionDispositivo = () =>
  //@ts-ignore
  useActionDispositivo(...([] as any[]));

export const __$$useUpdateRegistriDispositivo = () =>
  //@ts-ignore
  useUpdateRegistriDispositivo(...([] as any[]));

export const __$$useBancoFlussaggioCalcolaPortata = () =>
  //@ts-ignore
  useBancoFlussaggioCalcolaPortata(...([] as any[]));

export const __$$useUpdateNexus = () =>
  //@ts-ignore
  useUpdateNexus(...([] as any[]));

export const __$$useGetDispositivoHistoryData = () =>
  //@ts-ignore
  useGetDispositivoHistoryData(...([] as any[]));

export const __$$useGetDispositivoAnalisiData = () =>
  //@ts-ignore
  useGetDispositivoAnalisiData(...([] as any[]));

export const __$$useGenerateReportProprietaMisurata = () =>
  //@ts-ignore
  useGenerateReportProprietaMisurata(...([] as any[]));

export const __$$useGeneraCertificatoMQTT = () =>
  //@ts-ignore
  useGeneraCertificatoMQTT(...([] as any[]));
